import React, { Component, Fragment } from 'react'
import { Box, Paper, Grid } from '@material-ui/core'
import { connect } from 'react-redux';
import './styles.scss'

class Contact extends Component {
	render() {
		const { client } = this.props.user.info;
        const isClientBMW = client && client === "bmw";
		const isClientACG = client && client === "acg";
		const isClientHD = client && client === "hd";
		const isClientElan = client && client === "elan";
		return (
			<Fragment>
				<div id="contact" className="login-container">
					<Grid container spacing={0}>
						<Grid item sm={6}>
							<div className="contact-image-container" style={{
								backgroundImage: `url('${require('~/assets/images/login-bg.jpg')}')`
							}}></div>
						</Grid>
						<Grid item sm={6} xs={12}>
							<div className="contact-form-container">
								<div className="centered-container">
									<div className="logo-container">
										{isClientElan && <img alt="Elan" src={require('~/assets/images/contact-logo.png')} />}
										{isClientBMW && <img alt="BMW" style={{width: "250px"}} src={require('~/assets/images/bmw/logo.png')} />}
										{isClientACG && <img alt="ACG" style={{width: "250px"}} src={require('~/assets/images/acg/logo.png')} />}
										{isClientHD && <img alt="HD" style={{width: "250px"}} src={require('~/assets/images/hd/logo.png')} />}
									</div>
									{isClientHD ? "" : <h2>Contact</h2>}
									{isClientElan && <div className="elan-client-services">Elan Client Services</div>}
									{isClientBMW && <div className="elan-client-services">BMW Group Financial Services</div>}
									{isClientACG && <div className="elan-client-services">ACG Card Services</div>}
									{isClientHD ? "" : <>
									<div className="phone-email"><img src={require('~/assets/images/phone-call.png')} style={{ marginRight: '10px', verticalAlign: 'bottom'}}/> 1-800-523-5354</div>
									<div className="phone-email"><img src={require('~/assets/images/envelope.png')} style={{ marginRight: '10px', verticalAlign: 'bottom'}}/> clientservices@elanfs.com</div>
									</>}
									{isClientHD && <div className="message-hd-container">Need help with your CA$H IN redemption? Please use the Support Ticket at the top of the page.
									<br></br><br></br>
									
									For all Harley-Davidson<sup>®</sup> Visa<sup>®</sup> program inquiries please use the 'Contact Us' link on the H-D Resource Center Page.
									
									</div>}
								</div>
							</div>
						</Grid>
					</Grid>
				</div>
			
			</Fragment>
		)
	}
}

export default connect(state => ({ ...state.user }))(Contact);